// extracted by mini-css-extract-plugin
export default {"loginFormCenter":"LoginPage_loginFormCenter__G7OYG"};